var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncementHeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37818",
    "data-name": "Group 37818",
    transform: "translate(-1004 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1004, 32)",
    filter: "url(#Ellipse_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "loudspeaker-icon",
    d: "M0,14.881a2.655,2.655,0,0,1,1.625-2.8l.029-.048a.642.642,0,0,1,.132-.176.683.683,0,0,1,.231-.11l.064-.024a18.581,18.581,0,0,0,9.524-7.2,23.517,23.517,0,0,0,1.418,7.3,20.72,20.72,0,0,0,3.9,7h0A15.994,15.994,0,0,0,9.6,18.2a3.344,3.344,0,0,0-.247,1.115.86.86,0,0,0,.22.661l.053.049c.22.2.328.3.377.478a2.022,2.022,0,0,1-.029.71l-.02.148a.724.724,0,0,0,.542.91c.311.132.553.238.679.593a.15.15,0,0,1,0,.088,2.388,2.388,0,0,1-.977,1.387c-.1.09-.209.181-.3.267H9.891c-.864.692-1.448.507-1.891-.049a6.459,6.459,0,0,1-.816-1.722l-.1-.269A27.09,27.09,0,0,1,6.2,19.238l-.075-.331c-.192.053-.392.112-.6.174h0c-.265.077-.529.161-.791.245l-.084.031a.267.267,0,0,1-.293,0,2.847,2.847,0,0,1-3.329-1.3,5.511,5.511,0,0,1-.752-1.521A5.674,5.674,0,0,1,0,14.881ZM19.357,3.541a.661.661,0,0,1-.933-.132l-.015-.02a.672.672,0,0,1,.139-.924C19.619,1.674,20.686.876,21.758.1a.681.681,0,0,1,.489-.123.675.675,0,0,1,.441.267V.257A.661.661,0,0,1,22.8.748a.661.661,0,0,1-.267.441Zm3.481,12.72h0a.67.67,0,0,1-.653-.677v-.015a.661.661,0,0,1,.677-.661c1.184,0,2.387.044,3.571.066a.674.674,0,0,1,.456,1.157.661.661,0,0,1-.476.19l-3.569-.068Zm.1-3.463a.661.661,0,0,1-.716-.613V12.17a.677.677,0,0,1,.611-.712c1.1-.088,2.224-.183,3.329-.254a.675.675,0,0,1,.714.619h0a.661.661,0,0,1-.161.487.679.679,0,0,1-.459.234c-1.069.106-2.244.194-3.318.251Zm-.476-3.216a.675.675,0,0,1-.833-.465h0a.661.661,0,0,1,.06-.507.683.683,0,0,1,.4-.322c1.149-.3,2.293-.672,3.441-.981a.661.661,0,0,1,.507.06.679.679,0,0,1,.32.4h0A.677.677,0,0,1,25.9,8.6l-3.437.981ZM21.076,6.425a.672.672,0,0,1-.9-.3.661.661,0,0,1-.037-.514.681.681,0,0,1,.337-.39l3.307-1.651a.672.672,0,0,1,.937.816.677.677,0,0,1-.337.388L21.074,6.425Zm-8.126-3.8c.029-.033.06-.064.088-.093a.983.983,0,0,1,.326-.245h0a.789.789,0,0,1,.441-.018,3.08,3.08,0,0,1,1.567.994,20.5,20.5,0,0,1,3.708,6.7c.992,2.736,1.587,5.591,1.29,7.445a2.816,2.816,0,0,1-.73,1.616l-.02.015a1.243,1.243,0,0,1-.545.22.536.536,0,0,0-.055-.044,12.64,12.64,0,0,1-3.472-4.35,1.126,1.126,0,0,0,.882-.459,3.233,3.233,0,0,0-1.14-5.13,2.99,2.99,0,0,0-1.874-.112l-.033.018C12.679,6.465,12.479,3.947,12.951,2.624Z",
    transform: "translate(1026.001 49.488)",
    fill: "#2076eb",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementHeadIcon);
export default __webpack_public_path__ + "static/media/announcementHeadIcon.2f9598565a9e2e48f189eb756afa759a.svg";
export { ForwardRef as ReactComponent };